<script lang="ts">
  let {
    checked,
    onChange,
    label,
    disabled,
  }: { checked: boolean; onChange: (checked: boolean) => void; label: string; disabled?: boolean } = $props();
</script>

<label class="inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-md px-2 text-sm text-text transition-colors duration-[var(--dur-fast)] hover:bg-surface-2">
  <input
    type="checkbox"
    class="size-4 accent-[var(--accent-solid)]"
    {checked}
    {disabled}
    onchange={(e) => onChange(e.currentTarget.checked)}
  />{label}</label>
